import * as S from "./ExerciseState.style";
import { request } from "@/common/api";
import { useQuery } from "@tanstack/react-query";
import { ExerciseInfo } from "@/common/types/healthData";
import { useRecoilValue } from "recoil";
import { studentUserState } from "@/common/states/user";
import { GET_EXERCISE_INFO } from "@/common/querykeys";
import { ExerciseStateItem } from "@/components/atoms/ExerciseStateItem";
import { Loading } from "@/components/atoms/Loading";

export const ExerciseState = () => {
  const student = useRecoilValue(studentUserState);

  const { data: exerciseInfo, isPending } = useQuery<ExerciseInfo>({
    queryKey: [GET_EXERCISE_INFO],
    queryFn: async () => {
      return await request<ExerciseInfo>({
        method: "GET",
        url: `/exercise/exercise-info/${student.id}`,
      });
    },
  });

  return (
    <>
      {isPending ? (
        <Loading />
      ) : (
        <S.ExerciseStateBox>
          <S.ExerciseStateTit>나의 운동 참여 현황</S.ExerciseStateTit>
          <S.ExerciseStateContent>
            <ExerciseStateItem
              type="state"
              title="운동 참여 현황"
              data={exerciseInfo}
            />

            <ExerciseStateItem
              type="bonus"
              title="누적 참여"
              data={exerciseInfo}
            />
          </S.ExerciseStateContent>
        </S.ExerciseStateBox>
      )}
    </>
  );
};
